import { createContext } from 'react';
import type { BookingThemeTokens } from './personalities';

export const BookingTokensContext = createContext<BookingThemeTokens | null>(null);
